import { DateTime } from "luxon"

export const GroupModel = {
  name: "",
  description: ""
}

export const GroupValidator = {
  name: [
    {
      required: true,
      trigger: "blur",
      transform: (value: string) => value.trim()
    },
    {
      min: 2,
      trigger: "blur"
    },
    {
      max: 32,
      trigger: "blur"
    }
  ],
  description: {
    max: 1500,
    trigger: "blur"
  }
}

export const InvitationModel: {
  nbInvitations?: number
  expirationDate?: number
} = {}

export const InvitationValidator = {
  nbInvitations: {
    type: "integer",
    min: 1, 
    trigger: "blur"
  },
  expirationDate: {
    type: "number",
    min: DateTime.now().startOf("day").toMillis(),
    trigger: ["input", "blur"],
    message: "expiration date can't be in the past"
  }
}
